function NewFleetInfoController(CommonService, fleetService, $interval, $state) {
  const ctrl = this;
  const env = __env;
  const tryCatch = CommonService.tryCatch;
  const setSelectedTrain = CommonService.setSelectedTrain;
  const setSelectedCar = CommonService.setSelectedCar;

  ctrl.$onInit = async () => {
    ctrl.searchString = undefined;
    ctrl.loadedTrains = [];
    ctrl.trains = [];
    updateTrains(await fetchFleetInfo());
    ctrl.hasLinkToCarView = env.profile === 'VALE' || env.profile === 'DEMO';
    ctrl.wideTrains = env.profile === 'VALE' || env.profile === 'DEMO';
    ctrl.hasHighSpeedTrain = env.profile !== 'LU';
    ctrl.customMelco = env.profile === 'MELCO';
    startPoll();
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  ctrl.goToTrainPage = train => {
    setSelectedTrain(train);
    $state.go('train', {consist: train.status.trainId});
  };

  ctrl.goToCarView = (car, train) => {
    if (ctrl.hasLinkToCarView) {
      setSelectedTrain(train);
      setSelectedCar(car.carNumber);
      $state.go('car', {carNumber: car.carNumber, trainId: train.status.trainId});
    }
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 5000);
    }
  };

  const triggerFetchLoad = async () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -5) {
      updateTrains(await fetchFleetInfo());
    }
  };

  // Triggered with 500ms debounce each time
  // user types something in search filter field
  ctrl.searchChange = async () => {
    updateTrains(ctrl.loadedTrains);
  };

  const updateTrains = (trains) => {
    ctrl.loadedTrains = trains;
    ctrl.trains = filterTrains(ctrl.loadedTrains);
  }

  const filterTrains = (trains) => {
    if (!ctrl.searchString) {
      return trains;
    } else {
      return trains.filter(getTrainFilter())
    }
  }

  const getTrainFilter = () => {
    return train => !ctrl.searchString || !train ||!train.status
      || train.status.trainId && train.status.trainId.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.train && train.status.train.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.station && train.status.station.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.stationFull && train.status.stationFull.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.nextStation && train.status.nextStation.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.nextStationFull && train.status.nextStationFull.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.destinationStation && train.status.destinationStation.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.status.destinationStationFull && train.status.destinationStationFull.toLowerCase().includes(ctrl.searchString.toLowerCase())
      || train.carActiveEventStatuses && train.carActiveEventStatuses.filter(car => car.carNumber && car.carNumber.toLowerCase().includes(ctrl.searchString.toLowerCase())).length
  }

  // Fetch list of trains, wrapped in tryCatch, returns data if no error.
  const fetchFleetInfo = () =>
    tryCatch(async () => await fleetService.getSignOn())
      .fold(e => {
          console.error(`Event fetch error: ${e}`);
          return e;
        },
        data => data);
}

angular
  .module('gridlets.module')
  .controller('NewFleetInfoController', NewFleetInfoController);
